import { Suspense, useEffect } from 'react';

import { DialogProvider, ToastProvider } from '@aicon-dev/caas-ui';
import { App as CAPApp, URLOpenListenerEvent } from '@capacitor/app';
import { ConfigProvider, Skeleton } from 'antd';
import { ConfigProvider as MobileConfigProvider } from 'antd-mobile';
import koKR from 'antd-mobile/es/locales/ko-KR';
import { Outlet, ScrollRestoration, useNavigate } from 'react-router-dom';

import { AppErrorBoundary } from '~/components/common/ErrorBoundary/AppErrorBoundary';
import { AuthProvider } from '~/modules/auth/context/AuthProvider';
import { ChatAppProvider } from '~/modules/chat/context/ChatAppProvider';
import { Modals } from '~/routes';

export const Catch = () => {
  return (
    <Suspense>
      <AppErrorBoundary />
    </Suspense>
  );
};

export default function App() {
  const navigate = useNavigate();
  useEffect(() => {
    CAPApp.addListener('appUrlOpen', (event: URLOpenListenerEvent) => {
      // Example url: https://beerswift.app/tabs/tab2
      // slug = /tabs/tab2
      const slug = event.url.split('.app').pop();
      if (slug) {
        navigate(slug);
      }
      // If no match, do nothing - let regular routing
      // logic take over
    });
  }, []);

  return (
    <Suspense
      fallback={
        <div className="p-4">
          <Skeleton active />
        </div>
      }
    >
      <ScrollRestoration />
      <DialogProvider>
        <ToastProvider>
          <AuthProvider>
            <ConfigProvider>
              <MobileConfigProvider locale={koKR}>
                <ChatAppProvider>
                  <Outlet />
                  <Modals />
                </ChatAppProvider>
              </MobileConfigProvider>
            </ConfigProvider>
          </AuthProvider>
        </ToastProvider>
      </DialogProvider>
    </Suspense>
  );
}
